// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"80":"ff8282115cc628b21fa2","115":"ad26639abcf06e982522","678":"d4fbb89bb7ffd4cb21bd","680":"cbf699e9979d22ea8d86","932":"ecf64b88578ed3c7e260"}[chunkId] + ".js";
};